import React from 'react'
import { Image, StyleSheet } from '@react-pdf/renderer'

import Loadable from 'src/utils/Loadable'
import { TUseClientLogoResult } from 'src/parser/entities/Alarm/Preview/Provider/useClientLogo'

const MARGIN = 8
const MAX_WIDTH = 88
const HEIGHT = 32

const styles = StyleSheet.create({
  logo: {
    position: 'absolute',
    left: MARGIN,
    width: MAX_WIDTH,
    height: HEIGHT,
    objectFit: 'contain',
    objectPosition: 'left center',
  },
})

export const getClientLogoSource = (
  clientLogo: TUseClientLogoResult,
): string | null => {
  return Loadable.isSuccess(clientLogo) ? clientLogo.data : null
}

const HeaderLogo = ({ source }: { source: string }): JSX.Element => {
  return (
    <Image
      style={styles.logo}
      source={source}
    />
  )
}

export default HeaderLogo
